import { UserType } from "types/UserType";
import { isValidPhoneNumber } from "react-phone-number-input";

import { FormValues } from "./Registration";

const REQUIRED = "Поле обязательно для заполнения";

const isValidBirthDate = (value: string) => {
  if (!value) {
    return false;
  }

  const parts = value.split(".").reverse().map(Number) as [
    number,
    number,
    number
  ];

  if (parts.length !== 3) {
    return false;
  }

  const date = new Date(parts[0], parts[1] - 1, parts[2]);

  if (isNaN(date.valueOf())) {
    return false;
  }

  if (date.valueOf() > Date.now()) {
    return false;
  }

  if (
    date.getDate() !== parts[2] ||
    date.getMonth() !== parts[1] - 1 ||
    date.getFullYear() !== parts[0]
  ) {
    return false;
  }

  return true;
};

export const createValidation =
  (
    userType: UserType,
    isCustom?: boolean,
    isRequiredPhone?: boolean,
    isRequiredEmail?: boolean,
  ) => (values: FormValues) => {
    let errors: { [key in keyof FormValues]?: string } = {};

    const requiredFields = [
      "custom_lastname" as const,
      "custom_firstname" as const,
      "custom_дата_рождения" as const,
      "custom_sexint_save" as const,
      isRequiredPhone ? "custom_телефон" : null,
      isRequiredEmail ? "custom_login" : null,
      isCustom ? "custom_город" : null,
    ].filter(Boolean) as (keyof FormValues)[];

    requiredFields.forEach((key) => {
      if (!values[key]) {
        errors[key] = REQUIRED;
      }
    });

    if (!isValidBirthDate(values.custom_дата_рождения)) {
      errors.custom_дата_рождения =
        errors.custom_дата_рождения || "Некорректная дата";
    }

    if (isRequiredPhone && !isValidPhoneNumber(values.custom_телефон || "")) {
      errors.custom_телефон = errors.custom_телефон || "Некорректный номер";
    }

    if (Object.keys(errors).length) {
      return errors;
    }

    return undefined;
  };

export const epharmacyFormValidator = (values: FormValues) => {
  let errors: { [key in keyof FormValues]?: string } = {};

  const requiredFields = [
    "custom_дата_рождения" as const,
    "custom_sexint_save" as const,
  ].filter(Boolean) as (keyof FormValues)[];
  const numberFields = ["custom_масса_тела", "custom_рост"] as const;

  requiredFields.forEach((key) => {
    if (!values[key]) {
      errors[key] = REQUIRED;
    }
  });

  if (!isValidBirthDate(values.custom_дата_рождения)) {
    errors.custom_дата_рождения =
      errors.custom_дата_рождения || "Некорректная дата";
  }

  numberFields.forEach((key) => {
    const value = values[key] as string;

    if (!value) {
      return;
    }

    const isValid = /^\d{1,3}([,]\d{1,2})?$/.test(value);

    if (!isValid) {
      errors[key] = "Некорректное значение";
    }
  });

  if (Object.keys(errors).length) {
    return errors;
  }

  return undefined;
};